'use client';

import type { Variants, Transition } from 'framer-motion';

export const easeOutExpo: Transition['ease'] = [0.16, 1, 0.3, 1];

export const spring: Transition = { type: 'spring', stiffness: 260, damping: 24 };

export const fadeInUp = (
  distance = 24,
  rm = false,
  duration = 0.6,
  delay = 0
): Variants => ({
  hidden: { opacity: 0, y: rm ? 0 : distance },
  visible: {
    opacity: 1,
    y: 0,
    transition: rm ? { duration: 0 } : { duration, delay, ease: easeOutExpo },
  },
  exit: {
    opacity: 0,
    y: rm ? 0 : distance * 0.5,
    transition: rm ? { duration: 0 } : { duration: 0.3, ease: 'easeInOut' },
  },
});

export const scaleIn = (
  scaleFrom = 0.96,
  rm = false,
  duration = 0.35,
  delay = 0
): Variants => ({
  hidden: { opacity: 0, scale: rm ? 1 : scaleFrom },
  visible: {
    opacity: 1,
    scale: 1,
    transition: rm ? { duration: 0 } : { duration, delay, ease: easeOutExpo },
  },
  exit: {
    opacity: 0,
    scale: rm ? 1 : scaleFrom,
    transition: rm ? { duration: 0 } : { duration: 0.2, ease: 'easeInOut' },
  },
});

export const staggerContainer = (
  rm = false,
  stagger = 0.08,
  delayChildren = 0
): Variants => ({
  hidden: {},
  visible: {
    transition: rm ? {} : { staggerChildren: stagger, delayChildren },
  },
});

export const fadeItem = (rm = false, distance = 16): Variants => fadeInUp(distance, rm);

